export default function tableResize(e) {
  let wrap = document.querySelectorAll('.ag-center-cols-viewport'); //容器
  let right = document.querySelectorAll('.ag-pinned-right-cols-container'); //右侧固定列节点
  let rightHeader = document.querySelectorAll('.ag-pinned-right-header'); //右侧固定列表头节点
  let left = document.querySelectorAll('.ag-pinned-left-cols-container'); //右侧固定列节点
  let leftHeader = document.querySelectorAll('.ag-pinned-left-header'); //右侧固定列表头节点
  if (!e.target) {
    e.target = e;
  }
  // 如果是滚动事件（scroll），则根据滚动位置动态设置阴影效果。
  if (e.type && e.type == 'scroll') {
    try {
      if (wrap && right) {
        /*
          动态设置中间可滚动区的阴影效果
        */
        wrap.forEach((n, i) => {
          let handleFunction = e => {
            // 判断是否需要显示右侧固定列的阴影效果
            if (
              e.target.scrollWidth <=
              Number(e.target.scrollLeft) + Number(e.target.offsetWidth) + 2
            ) {
              right[i].style.boxShadow = 'none';
              rightHeader[i].style.boxShadow = 'none';
            }
            // 判断是否需要显示左侧固定列的阴影效果
            else if (e.target.scrollLeft == 0) {
              left[i].style.boxShadow = 'none';
              leftHeader[i].children[0] ? (leftHeader[i].children[0].style.boxShadow = 'none') : '';
            }
            // 其他情况下根据滚动位置设置阴影效果
            else {
              if (wrap[i].scrollLeft == 0) {
                // 显示右侧固定列的阴影效果
                right[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                rightHeader[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                right[i].style.zIndex = '10';
                rightHeader[i].style.zIndex = '10';
                // 隐藏左侧固定列的阴影效果
                left[i].style.boxShadow = 'none';
                leftHeader[i].children[0].style.boxShadow = 'none';
              } else if (
                wrap[i].scrollLeft > 0 &&
                wrap[i].scrollLeft < wrap[i].scrollWidth - wrap[i].offsetWidth
              ) {
                // 显示右侧固定列的阴影效果
                right[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                rightHeader[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                right[i].style.zIndex = '10';
                rightHeader[i].style.zIndex = '10';
                // 显示左侧固定列的阴影效果
                left[i].style.boxShadow = '4px 0 6px #E0E1E9';
                leftHeader[i].children[0]
                  ? (leftHeader[i].children[0].style.boxShadow = '4px 0 6px #E0E1E9')
                  : '';
                left[i].style.zIndex = '10';
                leftHeader[i].children[0] ? (leftHeader[i].children[0].style.zIndex = '10') : '';
              }
            }
          };
          handleFunction(e); //窗口尺寸变化
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
  // 如果是调整大小事件（resize），则根据表格宽度和滚动位置动态设置阴影效果。
  else if (e.type && e.type == 'resize') {
    try {
      if (wrap && right) {
        /*
                动态设置中间可滚动区的阴影效果
              */
        wrap.forEach((n, i) => {
          let handleFunction = e => {
            console.log('wrap[i]', wrap[i]);
            // 如果表格内容宽度等于表格容器宽度，则隐藏右侧固定列的阴影效果，并设置表格容器为隐藏溢出
            if (wrap[i].scrollWidth == wrap[i].clientWidth) {
              right[i].style.boxShadow = 'none';
              rightHeader[i].style.boxShadow = 'none';
              wrap[i].style.overflow = 'hidden';
            }
            // 如果滚动位置在最左侧，则隐藏左侧固定列的阴影效果，并设置表格容器为自动溢出
            else if (e.target.scrollLeft == 0) {
              left[i].style.boxShadow = 'none';
              leftHeader[i].children[0].style.boxShadow = 'none';
              wrap[i].style.overflow = 'auto';
            }
            // 其他情况下根据滚动位置设置阴影效果，并设置表格容器为自动溢出
            else {
              if (wrap[i].scrollLeft == 0) {
                // 显示右侧固定列的阴影效果
                right[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                rightHeader[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                right[i].style.zIndex = '10';
                rightHeader[i].style.zIndex = '10';
                // 隐藏左侧固定列的阴影效果
                left[i].style.boxShadow = 'none';
                leftHeader[i].children[0].style.boxShadow = 'none';
              } else if (
                wrap[i].scrollLeft > 0 &&
                wrap[i].scrollLeft < wrap[i].scrollWidth - wrap[i].offsetWidth
              ) {
                // 显示右侧固定列的阴影效果
                right[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                rightHeader[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
                right[i].style.zIndex = '10';
                rightHeader[i].style.zIndex = '10';
                // 显示左侧固定列的阴影效果
                left[i].style.boxShadow = '4px 0 6px #E0E1E9';
                leftHeader[i].children[0].style.boxShadow = '4px 0 6px #E0E1E9';
                left[i].style.zIndex = '10';
                leftHeader[i].children[0].style.zIndex = '10';
              }
              wrap[i].style.overflow = 'auto';
            }
          };

          handleFunction(e); //窗口尺寸变化
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
  // 其他情况下，根据表格宽度动态设置阴影效果。
  else {
    try {
      if (wrap && right) {
        /*
          动态设置中间可滚动区的阴影效果
        */
        wrap.forEach((n, i) => {
          let handleFunction = e => {
            if (e.target.scrollWidth > e.target.offsetWidth) {
              right[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
              rightHeader[i].style.boxShadow = '-4px 0px 6px 0px #E0E1E9';
              right[i].style.zIndex = '10';
              wrap[i].style.overflow = 'auto';
            } else if (wrap[i].scrollWidth == wrap[i].offsetWidth) {
              right[i].style.boxShadow = 'none';
              rightHeader[i].style.boxShadow = 'none';
              wrap[i].style.overflow = 'hidden';
            }
          };
          handleFunction(e); //窗口尺寸变化
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
}
